// extracted by mini-css-extract-plugin
export default {"bg-overlay":"m4khSP","bgOverlay":"m4khSP","bg-img-overlay":"FNxOn5","bgImgOverlay":"FNxOn5"};